import { Button, Center, Container, Group, Image, Paper, PinInput, Stack, Text, Title } from '@mantine/core'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { z } from 'zod'

import { useCheckRecoveryCodeMutation } from '../../api/auth/api'
import { RouterButton } from '../../components/RouterButton'

export const Route = createFileRoute('/recovery/otp-v2')({
  component: OtpScreen,
  validateSearch: z.object({
    email: z.string(),
  }),
})

function OtpScreen() {
  const [otp, setOtp] = useState('')
  const navigate = useNavigate()
  const { email } = Route.useSearch()

  const { mutate: checkOtp, isPending } = useCheckRecoveryCodeMutation()

  const onSubmit = () => {
    checkOtp(
      { email, code: otp },
      {
        onSuccess: () => {
          navigate({
            to: '/recovery/reset-v2',
            search: { email, code: otp },
          })
        },
      },
    )
  }

  return (
    <Stack
      align="center"
      justify="center"
      style={{
        height: '100vh',
        width: '100%',
        background: 'linear-gradient(135deg, #ff8800 0%, #ff6600 35%, #ff4400 100%)',
      }}
    >
      <Container size={600}>
        <Paper withBorder shadow="md" p={30} mt={30} radius="md" w={500}>
          <Image h={40} w="auto" fit="contain" src="/carma_partner_logo.svg" alt="Carma Logo" />

          <Title order={3} style={{ fontWeight: 700, color: '#333' }} mt="md">
            Enter the one time passcode
          </Title>
          <Text size="sm" mb={30}>
            {email ? `We sent a 4-digit code to ${email}.` : 'We sent a 4-digit code to your email.'}
          </Text>
          <Center>
            <PinInput length={4} type="number" size="xl" gap="md" placeholder="" onChange={setOtp} />
          </Center>
          <Group gap={8} justify="center" mt="xl">
            <RouterButton w={'49%'} variant="outline" to="/login">
              Return to login
            </RouterButton>
            <Button w={'49%'} onClick={onSubmit} loading={isPending} disabled={otp.length < 4}>
              Confirm
            </Button>
          </Group>
        </Paper>
      </Container>
    </Stack>
  )
}
